const main = {
    margin: '0',
    display: 'grid',
    padding: '0.25rem 0 0',
};
const cardHeader = {
    width: '100%',
    display: 'flex',
    padding: {
        desktop: '40px 80px',
        mobile: '40px 24px',
    },
};
const step2CTAWrapper = {
    mb: 0,
    display: 'flex',
    flexDirection: { desktop: 'row', mobile: 'column' },
    gap: '1rem',
    mt: { desktop: '6rem' },
    height: '40vh',
    justifyContent: 'flex-end',
};
const subtitle = {
    display: 'flex',
    flexDirection: {
        desktop: 'row',
        mobile: 'column',
    },
    justifyContent: 'space-between',
    width: '100%',
    '& .MuiButton-root': {
        width: {
            desktop: '192px',
            mobile: '100%',
        },
    },
    '& .MuiTypography-root': {
        alignSelf: 'flex-end',
        margin: {
            desktop: '1rem 0',
            mobile: '1rem 0',
        },
    },
};
const pageContentWrapper = {
    minWidth: { desktop: '50%', mobile: '100%' },
    backgroundColor: {
        desktop: 'white',
    },
    display: 'flex',
    gap: {
        mobile: '1rem',
        desktop: '0.5rem',
    },
    flexDirection: 'column',
    padding: {
        mobile: '24px',
        desktop: '40px',
    },
    ' .MuiTypography-root': {
        marginLeft: {
            mobile: '0',
        },
    },
    '> .MuiBox-root': {
        width: { desktop: '45%' },
    },
};
export default {
    step2CTAWrapper,
    main,
    cardHeader,
    pageContentWrapper,
    subtitle,
};
